export default {
    name: 'NewsIcon',
    props: [
        'domain'
    ],
    computed: {
        imageUrl: function() {
            return '//www.google.com/s2/favicons?domain=' + this.domain;
        }
    }
}

